import { useTheme } from "@/providers/ThemeProvider";
import { useNavigate } from "react-router-dom";
import { BeakerIcon } from "lucide-react";

export default function Logo({ size, justify }) {
  const width = size || "w-40";
  const { theme } = useTheme();
  const navigate = useNavigate();

  const navigateToHome = () => navigate("/");

  return (
    <div
      role="button"
      onClick={navigateToHome}
      className="flex items-center gap-3 cursor-pointer"
    >
      <img
        src="https://media.atomicatpages.net/u/xvMWv9TeqRbfe0S75EQu53KtBf33/Pictures/pxd07/YewDah4331682.png"
        alt="Logo"
        className={`${width} ${theme === 'dark' ? 'invert' : ''}`}
      />
    </div>
  );
}
